import { base32Encode } from './crockford'

export function encodeHardwareId(id) {
  return base32Encode(id)
}
